
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sfx/[sfxSlug]/[sfxId]/[variantId]",
      function () {
        return require("private-next-pages/sfx/[sfxSlug]/[sfxId]/[variantId].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sfx/[sfxSlug]/[sfxId]/[variantId]"])
      });
    }
  